export const DEFAULT_TABLE_PER_PAGE = 25;

export const DEFAULT_TABLE_PER_PAGES = [15, 25, 50, 100];

export function resolveTablePerPage(perPage, perPages = DEFAULT_TABLE_PER_PAGES) {
    const parsed = Number.parseInt(perPage, 10);

    if (Number.isFinite(parsed) && perPages.includes(parsed)) {
        return parsed;
    }

    if (perPages.includes(DEFAULT_TABLE_PER_PAGE)) {
        return DEFAULT_TABLE_PER_PAGE;
    }

    return perPages[0] ?? DEFAULT_TABLE_PER_PAGE;
}
